import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {ReactNode} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

export interface FormGroupProps {
  children?: ReactNode | null;
  className?: string;
  hasError?: boolean;
  dataTestAttrs?: DataTestAttrs;
  disableBottomMargin?: boolean;
}

function FormGroup(props: FormGroupProps): JSX.Element {
  const className = classNames(
    props.className,
    'form-group',
    {
      'has-error': props.hasError,
    },
    props.disableBottomMargin ? css(styles.marginBottomZero) : undefined
  );
  return (
    <div className={className} {...getTestProps(props.dataTestAttrs)}>
      {props.children}
    </div>
  );
}
FormGroup.displayName = 'FormGroup';

export default FormGroup;

const styles = StyleSheet.create({
  marginBottomZero: {marginBottom: 0},
});
